import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { RecommendationSliders, GenericRecommendationsContextProvider, BubbleRecommendations } from '@xp-utilities/web';
import { useIsS } from '../../hooks/useBreakPoint';
import $window from '../../utils/window';

export function TitleWrapper({ children }) {
  return <h2 className="h1">{children}</h2>;
}

export default function ProductRecommendations({
  usingProductRecs = false,
  usingBubbleRecs = false,
  usingMfeQuickview = false,
}) {
  const isMobile = useIsS();

  const handleProductClick = useCallback((event, product) => {
    const {
      id,
      collection,
      imageId,
      name,
      brand,
      faceout,
    } = product;

    const quickviewData = {
      productId: id,
      collectionId: collection,
      imageId,
      productName: name,
      productBrand: brand,
      returnFocus: event,
      faceout,
    };

    let eventName = 'quickview:openModal';
    if (usingMfeQuickview) {
      eventName = 'quickview:mfe:openModal';
    }

    const quickviewEvent = new CustomEvent(eventName, { detail: quickviewData });
    if (usingMfeQuickview) {
      $window.document.dispatchEvent(quickviewEvent);
    } else {
      $window.dispatchEvent(quickviewEvent);
    }
  }, [usingMfeQuickview]);

  const usingRecs = usingProductRecs || usingBubbleRecs;

  if (!usingRecs) {
    return null;
  }

  return (
    <div className="product-recs" data-testid={isMobile ? 'ful-dre-2-0-product-recs-mobile' : 'ful-dre-2-0-product-recs'}>
      <GenericRecommendationsContextProvider>
        { usingBubbleRecs && <BubbleRecommendations
          className="ful-recs-bubbles"
          placements={isMobile ? ['generic_page.m_category_returns_rr1'] : ['generic_page.category_returns_rr1']}
          fetchRecommendations={true}
          titleWrapper={TitleWrapper}
        />}
        { usingProductRecs && <RecommendationSliders
          onProductClick={handleProductClick}
          placements={isMobile ? ['generic_page.m_returns_rr1'] : ['generic_page.returns_rr1']}
        />}
      </GenericRecommendationsContextProvider>
    </div>
  );
}

ProductRecommendations.propTypes = {
  usingProductRecs: PropTypes.bool.isRequired,
  usingBubbleRecs: PropTypes.bool.isRequired,
  usingMfeQuickview: PropTypes.bool.isRequired,
};
